import { useTheme } from "@/contexts/ThemeContext";
import { Toaster as Sonner, type ToasterProps } from "sonner";

function ToastInfoIcon() {
  return (
    <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
      <circle cx="10" cy="10" r="10" fill="#F79009" />
      <circle cx="10" cy="6" r="1.2" fill="#fff" />
      <rect x="9.1" y="8.35" width="1.8" height="6.5" rx="0.9" fill="#fff" />
    </svg>
  );
}

function ToastSuccessIcon() {
  return (
    <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
      <circle cx="10" cy="10" r="10" fill="#12B76A" />
      <path
        d="M5.8 10.4 8.4 13l5.8-6.2"
        fill="none"
        stroke="#fff"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ToastErrorIcon() {
  return (
    <svg viewBox="0 0 20 20" width="20" height="20" aria-hidden="true">
      <path
        fill="#F04438"
        d="M6.3 1.4h7.4L18.6 6.3v7.4l-4.9 4.9H6.3L1.4 13.7V6.3L6.3 1.4z"
      />
      <path d="M10 6.1v5.1" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" />
      <circle cx="10" cy="13.7" r="1.05" fill="#fff" />
    </svg>
  );
}

function ToastCloseIcon() {
  return (
    <svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true">
      <path
        d="M2.2 2.2 9.8 9.8M9.8 2.2 2.2 9.8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      dir="rtl"
      position="bottom-center"
      offset={24}
      expand={false}
      visibleToasts={3}
      duration={4200}
      gap={10}
      closeButton
      className="toaster group"
      icons={{
        success: <ToastSuccessIcon />,
        error: <ToastErrorIcon />,
        info: <ToastInfoIcon />,
        warning: <ToastInfoIcon />,
        close: <ToastCloseIcon />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast: "app-toast group",
          title: "app-toast-title",
          description: "app-toast-description",
          actionButton: "app-toast-action",
          cancelButton: "app-toast-cancel",
          closeButton: "app-toast-close",
          icon: "app-toast-icon",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
